/**
 * Indicates that a value exists within a provided enum.
 * @param obj - An enum object.
 * @param value - A value.
 * @returns A boolean.
 */
export const isValueInEnum = <T>(obj: Record<string, T>, value: T): boolean => {
  return Object.values(obj).includes(value);
};

export const enum EventType {
  FIELD_CHANGED = 'FIELD_CHANGED',
  SET_VALUE = 'SET_VALUE',
  LOAD_VALUES = 'LOAD_VALUES',
  ERROR = 'ERROR',
  SET_CONDITIONAL_REQUIRED = 'SET_CONDITIONAL_REQUIRED',
}

export const enum FormEvent {
  OnChangeEventMessage = 'onChangeEventMessage',
  LoadCountiesByZipCode = 'LoadCountiesByZipCode',
  LoadCountiesData = 'LoadCountiesData',
  LoadEventTitleById = 'LoadEventTitleById',
  LoadPiwikSessionId = 'LoadPiwikSessionId',
  LoadCurrentPageUrl = 'LoadCurrentPageUrl',
  LoadMCPId = 'LoadMCPId',
  LoadEventOccurrenceEvolveId = 'LoadEventOccurrenceEvolveId',
  SetConditionalRequiredFlag = 'SetConditionalRequiredFlag',
}

export const enum StatusCode {
  OK = 200,
  PermanentRedirect = 301,
  TemporaryRedirect = 302,
  InvalidRequest = 400,
  NotAuthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  ServerError = 500,
}

export enum EvolveUrl {
  Production = 'https://member.evolvenxt.com/',
  Preview = 'https://member.sb.evolvenxt.com/',
  EvolveHandler = '/api/handlers/evolve',
}

export const enum Components {
  JssNextForm = 'JssNextForm',
}
